// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Climb",
  id: "climb",
  metadata: {
    aspect: SavedSpellAspect.Earth,
    imports: ["earth","vector","aim","shapes"],
    icon: {
      "backgroundColor": 2893587,
      "layers": [
        {
          "iconKey": "earthSpike",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -3,
          "color": 12884836
        },
        {
          "iconKey": "aim",
          "position": {
            "x": 16,
            "y": -2
          },
          "scale": 0.66,
          "rotation": -18,
          "color": 16777203
        }
      ]
    },
  },
};

export default metadata;
